import SectionHeader from '../components/SectionHeader';
import { blogPosts } from '../data/content';
import { Link } from 'react-router-dom';

function Blog() {
  return (
    <section className="content-section page-section">
      <SectionHeader label="Blog" title="Latest industry articles" />
      <div className="card-grid blog-grid">
        {blogPosts.map((post) => (
          <div key={post.title} className="blog-card">
            <h3>{post.title}</h3>
            <p>{post.excerpt}</p>
            <Link to="/single" className="link-button">
              Read Article
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Blog;
